import { CoffeeIcon } from './CoffeeIcon';

/**
 * author: Google
 * id C95D04C5-F5EE-411A-88F7-A9872B2B4021
 * name coffee
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/coffee.svg
 * tags
 * - Food / Drink 
 */
export const FreeBreakfastIcon = CoffeeIcon;
export default FreeBreakfastIcon